import React, { Component } from "react";

import { CardBody, Title, Copy } from "app/NativeComponents/common";

class BadgeTitle extends Component {
  render() {
    if (this.props.badge.seen_badge == false) {
      return (
        <CardBody style={{ alignItems: "center" }}>
          <Title style={{ color: "#FFF", fontSize: 28 }}>Congrats!</Title>
          <Title style={{ color: "#FFF", fontSize: 22 }}>
            You've earned the
          </Title>
          <Title style={{ color: "#FFF", fontSize: 22, marginTop: 20 }}>
            {this.props.badge.title}
          </Title>
        </CardBody>
      );
    } else {
      return (
        <CardBody style={{ alignItems: "center" }}>
          <Title style={{ color: "#FFF", fontSize: 24 }}>
            {this.props.badge.title}
          </Title>
        </CardBody>
      );
    }
  }
}

export default BadgeTitle;
